import React from "react";
import "./styles/SavingsSummary.css";

interface SavingsSummaryProps {
  monthlyBill: number;
  offsetPercent: number;
  systemLife: number;
  finalSystemSize: number;
  finalSystemCost: number;
  annualSavings: number;
  totalSavings: number;
  monthlyLoanPayment: number;
  paybackPeriod: number;
  roi: number;
  isFinanced: boolean;
  pricePerWatt: number;
}

export default function SavingsSummary({
  monthlyBill,
  offsetPercent,
  systemLife,
  finalSystemSize,
  finalSystemCost,
  annualSavings,
  totalSavings,
  monthlyLoanPayment,
  paybackPeriod,
  roi,
  isFinanced,
  pricePerWatt,
}: SavingsSummaryProps) {
  return (
    <div className="savings-summary">
      <h2>Savings Summary</h2>
      <div className="summary-grid">
        <div className="summary-item">
          <h3>Current Monthly Bill</h3>
          <p>${monthlyBill.toLocaleString()}</p>
        </div>
        <div className="summary-item">
          <h3>Solar Offset</h3>
          <p>{offsetPercent}%</p>
        </div>
        <div className="summary-item">
          <h3>System Size</h3>
          <p>{finalSystemSize.toFixed(2)} kW</p>
        </div>
        <div className="summary-item">
          <h3>Price Per Watt</h3>
          <p>${pricePerWatt.toFixed(2)}</p>
        </div>
        <div className="summary-item">
          <h3>System Cost</h3>
          <p>${finalSystemCost.toLocaleString(undefined, { maximumFractionDigits: 0 })}</p>
        </div>
        {isFinanced && (
          <div className="summary-item">
            <h3>Monthly Loan Payment</h3>
            <p>${monthlyLoanPayment.toLocaleString()}</p>
          </div>
        )}
        <div className="summary-item">
          <h3>Annual Savings</h3>
          <p>${annualSavings.toLocaleString()}</p>
        </div>
        <div className="summary-item">
          <h3>{systemLife}-Year Total Savings</h3>
          <p>${totalSavings.toLocaleString()}</p>
        </div>
        <div className="summary-item">
          <h3>Payback Period</h3>
          <p>{paybackPeriod.toFixed(1)} years</p>
        </div>
        <div className="summary-item">
          <h3>Return on Investment</h3>
          <p>{roi.toFixed(1)}%</p>
        </div>
      </div>
    </div>
  );
} 